import { QuickActionsMenu } from 'modules/quickActionsMenu';
import { QuickActionsMenuContextProvider } from 'modules/quickActionsMenu/contexts';
import React, { useEffect } from 'react';
import { FULL_SCREEN_CLASS } from './FullScreenLayout.constants';
import { FullScreenAppWrapper, GlobalStyle } from './FullScreenLayout.styles';

/*
  FullScreenLayout is mostly similar to DefaultLayout with a few important distinctions:
  - Uses flexbox to stretch to the width and height of the screen and contains no scroll bars
  - Does not contain a footer
*/

const FullScreenLayout = ({ children }: { children?: React.ReactNode | undefined }) => {
  useEffect(() => {
    document?.querySelector?.('html')?.classList.add(FULL_SCREEN_CLASS);

    return () => {
      document?.querySelector?.('html')?.classList.remove(FULL_SCREEN_CLASS);
    };
  }, []);

  return (
    <>
      <GlobalStyle />
      <QuickActionsMenuContextProvider>
        <QuickActionsMenu />
      </QuickActionsMenuContextProvider>
      <FullScreenAppWrapper data-global-nav={true} data-id="routes-container">
        {children}
      </FullScreenAppWrapper>
    </>
  );
};

export default FullScreenLayout;
